// extracted by css-extract-rspack-plugin
export default {"field":"qJy69CEEa44qRc0k","fieldLabel":"Sk1_dul3MzE3t9Zj","titleText":"Jizw4FbKJDI_JMHN","red":"gG0L7D6f3eA3y5Bo"};